<template>
<div class="MarketingDaily" v-if="init">
    <div class="summary">
        <div class="box bgc box-shadow">
            <div class="name">今日支付金额</div>
            <div class="value">￥{{summary.todayordermoney}}</div>
        </div>
        <div class="box bgc box-shadow">
            <div class="name">昨日支付金额</div>
            <div class="value">￥{{summary.yesordermoney}}</div>
        </div>
    </div>
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <div class="name">
                            <span>总订单数</span>
                        </div>
                        <div class="value tc-blue">{{summary.ordercount}}</div>
                    </div>
                    <div class="box">
                        <div class="name">
                            <span>总支付金额</span>
                        </div>
                        <div class="value tc-green">￥{{summary.ordermoney}}</div>
                    </div>
                    <div class="box">
                        <div class="name">
                            <span>总退款金额</span>
                        </div>
                        <div class="value tc-red">￥{{summary.refundmoney}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">
                        今天
                    </el-button>
                    <el-button type="primary" @click="handleQuery(2)"
                               :class="[param.timetype!=2?'is-disabled': '']">昨天
                    </el-button>
                    <el-button type="success" @click="handleQuery(3)"
                               :class="[param.timetype!=3?'is-disabled': '']">近7天
                    </el-button>
                    <el-button type="warning" @click="handleQuery(4)"
                               :class="[param.timetype!=4?'is-disabled': '']">近30天
                    </el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div class="echert">
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
    <div class="list bgc">
        <div class="result-list btn-operate-list bgc">
            <div class="tableData">
                <div class="lengdeList box">
                    <span class="lengdeName blod innerbox">时间</span>
                    <span class="lengdeName blod innerbox">订单数</span>
                    <span class="lengdeName blod innerbox">支付金额（元）</span>
                    <span class="lengdeName blod innerbox">退款金额（元）</span>
                </div>
                <div v-for="(obj,index) in tableData" :key="index">
                    <div class="box">
                        <span class="innerbox">{{obj.date}}</span>
                        <span class="innerbox">{{obj.ordercount}}</span>
                        <span class="innerbox">￥{{obj.ordermoney}}</span>
                        <span class="innerbox">￥{{obj.refundmoney}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataAnalysisSaleDataByBrand, getDataAnalysisSaleData, exportDataAnalysisSaleDataByBrand} from 'api/brandBusiness'
export default {
    name: 'MarketingDaily',
    data() {
        return {
            summary: {
                ordercount: 0,
                ordermoney: '0.00',
                refundmoney: '0.00',
                todayordermoney: '0.00',
                yesordermoney: '0.00'
            },
            param: {
                begintime: '',
                endtime: '',
                timetype: 3 //  0自定义 1今日 2昨日 3近7日 4近30日
            },
            lineDatas: {id: 'saleData', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}'},
            date: [],
            tableData: [],
            init: false
        }
    },
    mounted() {
        this._getDataAnalysisSaleData ()
        this._getDataAnalysisSaleDataByBrand()
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begintime = this.date[0]
                this.param.endtime = this.date[1]
            }
            this.param.timetype = index
            this._getDataAnalysisSaleDataByBrand()
        },
        handleExport() {
            this.setLoading(true)
            exportDataAnalysisSaleDataByBrand({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '营销日报' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getDataAnalysisSaleData() {
            this.setLoading(true)
            getDataAnalysisSaleData({
                data: {},
                success: data => {
                    this.summary = data.data
                    this.init = true
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getDataAnalysisSaleDataByBrand() {
            this.setLoading(true)
            getDataAnalysisSaleDataByBrand({
                data: Object.assign({}, this.param),
                success: data => {
                    this.tableData = data.data.datalist
                    this.lineDatas.xdata = data.data.datelist
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '订单数',
                            color: '#5AD8A6',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.orderlist
                        }
                    )
                    this.lineDatas.data.push(
                        {
                            title: '支付金额',
                            color: '#5B8FF9',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.ordermoneylist
                        }
                    )
                    this.lineDatas.data.push(
                        {
                            title: '退款金额',
                            color: '#5D7092',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.refundmoneylist
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.MarketingDaily {

}
</style>
